import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  selectedPermissions: [],

  roles: [],
  role: {},
  selectedRoles: [],

  ramais: [],
  selectedRamaisRelatoriosPABX: [],
  selectedRamaisMonitorRamais: [],

  tags: [],
  selectedTagsRelatoriosPABX: [],
  selectedTagsPesquisaSatisfacao: [],

  conferencias: [],
  selectedConferencias: [],

  filas: [],
  selectedFilas: [],

  departamentos: [],
  selectedDepartamentos: [],
  
  operadores: [],
  selectedOperadores: [],

  pesquisasSatisfacao: [],
  selectedPesquisasSatisfacao: [],

  permissoesUsuariosCadastroUsuarioTotal: false,

  step: 1,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
